/**
 * useDiningOptions Composable
 * Simple adapter for dining options operations
 * Delegates all business logic to store actions
 * Compatible with Vue 2
 */

/**
 * Composable for managing dining options
 * @param {Object} store - Vuex store instance
 * @returns {Object} Dining options methods (all delegate to store)
 */
export function useDiningOptions(store) {
  if (!store) {
    console.warn("useDiningOptions: Store instance is required");
    return {
      isScheduleEnabled: () => false,
      setDiningOptionByType: async () => ({ success: false })
    };
  }

  /**
   * Checks if scheduling is enabled for current dining option
   * Delegates to store action
   * @returns {boolean} Whether scheduling is enabled
   */
  function isScheduleEnabled() {
    return store.getters["store/isScheduleEnabled"] || false;
  }

  /**
   * Sets dining option by order type
   * Delegates to store action (all business logic there)
   * @param {string} orderType - Order type ('pickup', 'curbside', 'delivery')
   * @returns {Promise<Object>} { success: boolean, option: Object|null }
   */
  async function setDiningOptionByType(orderType) {
    if (!orderType) {
      console.warn("useDiningOptions: Invalid order type");
      return { success: false, option: null };
    }

    // Delegate to store action (all business logic there)
    return await store.dispatch("store/setDiningOptionByType", orderType);
  }

  return {
    isScheduleEnabled,
    setDiningOptionByType
  };
}
